import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import { I18nPage } from 'i18n/types/pages.enum';
import { getShopProducts } from 'evcharging/services/cmsClient';
import ShopHeader from 'containers/shop/ShopHeader';
import ShopGrid from 'containers/shop/ShopGrid';
import { ShopProduct } from 'evcharging/services/types';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';

interface ShopProps extends StaticPageProps {
  products: ShopProduct[];
}

const category = 'thermostats';
const baseUrl = '/services/thermostat';

const Index: FC<ShopProps> = (props) => {
  const { page, products } = props;
  const [first, ...rest] = products;

  return (
    <Page
      locales={page.locales}
      title={page.meta_title}
      description={page.meta_description}
    >
      <Navigation hideSubNav />
      {first && (<ShopHeader
        product={first}
        title={'Guiding Your Choice in Thermostat Solutions'}
        description={'Take control of your comfort with our thermostat services. Enjoy precise temperature management and energy savings at your fingertips'}
        baseUrl={baseUrl}
      />)}
      <ShopGrid products={rest} baseUrl={baseUrl} />
      {/*<ShopPopular products={products.slice(0, 3)} />*/}
      <RequestConsultation />
      <Footer />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, async (context, locale) => {
    return { products: await getShopProducts(category) };
  },
  [I18nPage.AboutUs, I18nPage.Home]
);

export default Index;
